<template>
    <section class="MediaElement ContentSection">
        <div v-if="properties.text !== ''" v-html="properties.text" class="MediaElement__text"></div>
        <Media :props="properties"></Media>
    </section>
</template>
<script>
import Media from '../util/Media.vue';

export default {
    props: ["properties", "pageData"],
    components: {
        Media
    }
}
</script>
<style lang="scss">
    .MediaElement {
        text-align: left;
        padding-top: 120px;
        padding-bottom: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .MediaElement__text {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            margin-bottom: 40px;
        }
    }
</style>